(function () {
    // hold onto the drop down menu                                             
    let dropdownMenu;

    // and when you show it, move it to the body                                     
    $(window).on('show.bs.dropdown', function (e) {

        if ($(e.target).hasClass('body-attached')) {
            // grab the menu        
            dropdownMenu = $(e.target).find('.dropdown-menu');

            // detach it and append it to the body
            $('body').append(dropdownMenu.detach());

            // grab the new offset position
            let eOffset = $(e.target).offset();
          
            // make sure to place it where it would normally go (this could be improved)
            if(document.dir === 'rtl'){
                
                dropdownMenu.css({
                    'display': 'block',
                    'top': eOffset.top + $(e.target).outerHeight(),
                    'left': 'auto',
                    'right': window.innerWidth - eOffset.left
                });
                
            } else {
                dropdownMenu.css({
                    'display': 'block',
                    'top': eOffset.top + $(e.target).outerHeight(),
                    'left': eOffset.left
                });
            }
        }

    });


    // and when you hide it, reattach the drop down, and hide it normally                                                   
    $(window).on('hide.bs.dropdown', function (e) {

        if (dropdownMenu) {
            $(e.target).append(dropdownMenu.detach());
            dropdownMenu.hide();
        }
    });
    
    /*$('body').on('click', '[data-toggle="dropdown2"]', function () {
        $(this).dropdown('toggle')
    })*/
    
    const customMod = {
        order: 0,
        enable: true,
        fn: data => {
            const hash = { end: 'start', start: 'end' };
            data.placement = placement.replace(/start|end/g, matched => hash[matched]);
            return data;
        }
    };
    const dropdown2 = function ($els) {
        $els.dropdown({
            //boundary: 'viewport',
            popperConfig: {
                modifiers: {
                    computeStyle: {
                        gpuAcceleration: false
                    }/*,
                    customMod*/
                }
            }
        });
    }
    window['dropdown2'] = dropdown2;
    $('.dropdown-toggle2').dropdown('dispose')
    dropdown2($('.dropdown-toggle2'));
})();

export default {};
